import React, { useEffect, useState, memo } from "react";
import { Tabs } from "antd";
import LicensesTab from "@Components/licenses/LicensesTab";
import AudiencesTab from "@Components/licenses/AudiencesTab";
import { useLocation } from "react-router";
import PageHelmet from "@Components/shared/PageHelmet";
import "@Styles/pages/licensesPage.scss";
import { useHistory } from "react-router-dom";
type LicenseTabs = "#licenses" | "#audiences";

const LicensesPage: React.FC = () => {
    const [activeKey, setActiveKey] = useState<LicenseTabs>("#licenses");
    const { hash } = useLocation();
    const history = useHistory();

    /**
     * Change the current navigation tab.
     * @param key
     */
    const handleTabChange = (key: LicenseTabs) => {
        setActiveKey(key);
        history.push(`/licenses${key}`);
    };

    useEffect(() => {
        setActiveKey(hash as LicenseTabs);
    }, [hash]);

    useEffect(() => {
        setActiveKey(hash as LicenseTabs);
    }, []);

    return (
        <article className="licenses-page">
            <PageHelmet name={"Licenses"} />
            <Tabs className={"newUI-raised"} type="card" activeKey={activeKey} onChange={handleTabChange} centered>
                <Tabs.TabPane tab="Licenses" key="#licenses">
                    <LicensesTab />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Audiences" key="#audiences">
                    <AudiencesTab />
                </Tabs.TabPane>
            </Tabs>
        </article>
    );
};
export default memo(LicensesPage);
